import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import OverviewProductSalesMTD from './components/biReports/OverviewProductSalesMTD';
import OverviewTopClassShareMTD from './components/biReports/OverviewTopClassShareMTD';
import OverviewTopCategoryShareMTD from './components/biReports/OverviewTopCategoryShareMTD';
import OverviewTopSubCategoryShareMTD from './components/biReports/OverviewTopSubCategoryShareMTD';
import OverviewClassSales from './components/biReports/OverviewClassSales';
import SalesYTDCategoryChart from './components/biReports/SalesYTDCategoryChart';
import CategLocationChartGroup from './components/biReports/CategLocationChartGroup';

import Client from './components/Client';
// import Config from './components/ClientConfig';

class RapProducts2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      /* locationGroups: null, */
      edit: false,
    };
  }

  componentDidMount() {
    if (this.props.onReady) {
      this.props.onReady();
    }
  }

  componentWillUnmount() {
  }

  /* setLocationsGroups ( groups ) {
    let a = { }
    if ( groups !== null && groups !== undefined ) {
      groups.map ( (locationGroup) => {
        a [ locationGroup.iref ] = locationGroup;
      });
      this.setState ( { locationGroups : a });
    }
  } */

  render() {
    const fullWidthChildSx = {
      width: '100%',
      minWidth: 0,
      '& > *': {
        width: '100% !important',
        maxWidth: '100% !important',
        mx: '0 !important',
        boxSizing: 'border-box',
      },
    };

    const reportBoxSx = {
      width: '100%',
      minWidth: 0,
      '& > *': {
        width: '100% !important',
        maxWidth: '100% !important',
        boxSizing: 'border-box',
      },
      '& .MuiCard-root': {
        borderRadius: { xs: '14px', sm: '16px' },
        boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
        border: '1px solid rgba(15, 23, 42, 0.06)',
      },
    };

    return (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          maxWidth: {
            xs: 'calc(100vw - 8px)',
            sm: '100%',
          },
          ml: {
            xs: 'calc(50% - 50vw + 4px)',
            sm: 0,
          },
          // bgcolor: '#f3f6fa',
          overflowX: 'hidden',
          pt: { xs: 0.75, sm: 1.5, md: 3 },
          pb: { xs: 1, sm: 2, md: 3 },
          px: { xs: 0.5, sm: 1, md: 2 },
          boxSizing: 'border-box',

          '& .MuiGrid-item': {
            minWidth: 0,
          },
          '& .MuiCard-root': {
            maxWidth: '100%',
            boxSizing: 'border-box',
          },
        }}
      >
        <Grid
          container
          spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
          sx={{
            width: '100%',
            maxWidth: '100%',
            m: 0,
          }}
        >
          <Grid item xs={12} sx={{ p: '0 !important' }}>
            <Grid
              container
              spacing={{ xs: 0.75, sm: 1, md: 1.5 }}
              sx={{
                width: '100%',
                m: 0,
              }}
            >
              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewProductSalesMTD />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewTopClassShareMTD />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewTopCategoryShareMTD />
                </Box>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={6}>
                <Box sx={fullWidthChildSx}>
                  <OverviewTopSubCategoryShareMTD />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={12} sx={{ p: '0 !important', mt: { xs: 0.75, md: 1.5 } }}>
            <Box sx={reportBoxSx}>
              <OverviewClassSales />
            </Box>
          </Grid>

          <Grid item xs={12} md={6} lg={6} sx={{ pl: '0 !important' }}>
            <Box sx={reportBoxSx}>
              <CategLocationChartGroup />
            </Box>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Box sx={reportBoxSx}>
              <SalesYTDCategoryChart />
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default RapProducts2;